module.exports = __webpack_public_path__ + "media/images/logos/logo_apple-watch-49f9952279535ace65142010a2da6386.png";